import React, { useEffect, useState } from "react";
import Immunization from '../../../../globalcomponents/patient360/medicalhistory/immunization'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientImmunization = (props) => {
  return (
    <>
      <Immunization data={props.formValues.patientdata} app="Patient" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientImmunization));

